var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_111_630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 34C18.825 34 16.0315 32.948 13.6195 30.844C11.2065 28.7391 10 25.8913 10 22.3006C10 20.0416 10.9 17.5924 12.7 14.9529C14.5 12.3134 17.225 9.45987 20.875 6.39236C21.025 6.27346 21.2 6.17834 21.4 6.10701C21.6 6.03567 21.8 6 22 6C22.2 6 22.4 6.03567 22.6 6.10701C22.8 6.17834 22.975 6.27346 23.125 6.39236C26.775 9.45987 29.5 12.3134 31.3 14.9529C33.1 17.5924 34 20.0416 34 22.3006C34 25.8913 32.7935 28.7391 30.3805 30.844C27.9685 32.948 25.175 34 22 34ZM22.4125 29.7197C22.7125 29.696 22.969 29.5833 23.182 29.3816C23.394 29.179 23.5 28.935 23.5 28.6497C23.5 28.3168 23.3875 28.0495 23.1625 27.8478C22.9375 27.6452 22.65 27.5558 22.3 27.5796C21.275 27.651 20.1875 27.3837 19.0375 26.7778C17.8875 26.1709 17.1625 25.0709 16.8625 23.4777C16.8125 23.2161 16.681 23.0021 16.468 22.8357C16.256 22.6692 16.0125 22.586 15.7375 22.586C15.3875 22.586 15.1 22.7106 14.875 22.9598C14.65 23.21 14.575 23.5015 14.65 23.8344C15.075 25.9983 16.075 27.5439 17.65 28.4713C19.225 29.3987 20.8125 29.8149 22.4125 29.7197Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_630",
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_630",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityIcon);
export default __webpack_public_path__ + "static/media/HumidityIcon.7f72f014fe662b6cfd04ad0ccb56146a.svg";
export { ForwardRef as ReactComponent };